import React from 'react';

const RenderHTMLFromString = ({ htmlString }) => {
  return <div key={htmlString} dangerouslySetInnerHTML={{ __html: htmlString }} />;
};

export default RenderHTMLFromString;
